import { createFileRoute } from '@tanstack/react-router'

import { JobDetailPage } from '@/features/jobs/JobDetailPage'

export const Route = createFileRoute('/_app/jobs/$jobId')({
  component: JobDetailRouteComponent,
})

function JobDetailRouteComponent() {
  const { jobId } = Route.useParams()
  return <JobDetailPage jobId={jobId} />
}
